import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SweetAlertService } from 'app/core/services/sweet-alert.service';
import { AuthService } from 'app/modules/auth/auth.service';

/**
 * Inspections and Call Center are activated per community from the admin portal.
 * The profile exposes `company.has_inspections` / `company.has_call_center` when at least one active community has the module on.
 */
const moduleEnabledGuard =
  (flag: 'has_inspections' | 'has_call_center', label: string): CanActivateFn =>
  () => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const sweetAlert = inject(SweetAlertService);

    if (!authService.profile()?.company?.[flag]) {
      sweetAlert.error(`${label} is not activated for any of your communities. Please contact the system administrator.`);
      return router.createUrlTree(['/dashboard']);
    }

    return true;
  };

export const inspectionsEnabledGuard: CanActivateFn = moduleEnabledGuard('has_inspections', 'Inspection');

export const callCenterEnabledGuard: CanActivateFn = moduleEnabledGuard('has_call_center', 'Call Center');
